var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF4081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81313 12.0954L7.902 14.0624C7.902 14.0624 8.95669 13.8835 10.0552 14.0624L10.143 12.0954H7.81313ZM6.53963 10.5749C6.53963 10.5749 9.61594 10.3066 11.4176 10.5749L11.5931 8.42898C9.88194 8.29628 8.16306 8.29628 6.45188 8.42898L6.53963 10.5749ZM14.625 5.03092C14.625 5.03092 8.73619 3.77879 3.375 5.12035L3.77044 7.57904L4.25419 6.64023C4.25419 6.64023 9.30769 5.88029 13.8336 6.64023L14.2734 7.57961L14.625 5.03092Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnt);
export default __webpack_public_path__ + "static/media/tnt.450de9084ea3a2707a030078de4fb1d8.svg";
export { ForwardRef as ReactComponent };